import React, { useEffect, useMemo, useState } from 'react'
import { LeftOutlined, RightOutlined } from '@ant-design/icons'
import styles from './index.module.less'
import classNames from 'classnames'

interface PaginationProps {
  total?: number
  onChange?: Function
  page?: number
  pageSize?: number
}
export default function Pagination({
  onChange,
  total = 0,
  page = 1,
  pageSize = 20,
}: PaginationProps) {
  const [number, setNumber] = useState(1)

  // 分页数量
  const pageNumber = useMemo(() => {
    if (!total) return 0
    return Math.ceil(total / pageSize)
  }, [total, pageSize])

  useEffect(() => {
    if (!page) return
    setNumber(page || 1)
  }, [page])

  return (
    <div className={styles.pagination}>
      <div
        className={styles.arrow}
        onClick={() => {
          if (number === 1) return
          setNumber(number - 1)
          onChange?.(number - 1, pageSize)
        }}
      >
        <LeftOutlined className={classNames(number === 1 && styles.disabled)} />
      </div>
      <p className={styles.text}>
        {total && (
          <>
            <span>{number}</span>/{pageNumber}
          </>
        )}
      </p>
      <div
        className={styles.arrow}
        onClick={() => {
          if (number === pageNumber) return
          setNumber(number + 1)
          onChange?.(number + 1, pageSize)
        }}
      >
        <RightOutlined
          className={classNames(number === total && styles.disabled)}
        />
      </div>
    </div>
  )
}
